import React, { useState, useEffect, useRef } from "react";
import { mergeStyles } from "../../utils/utilStyles";

const baseStyle = {
  backgroundColor: "bg-ov-gray-200",
  textColor: "text-gray-600",
  height: "h-8",
  selectedColor: "bg-white",
  selectedTextColor: "text-gray-700",
};

const MultiToggleOptions = ({ width = null, selectedOption, options, setSelectedOption, overrideStyle = {} }) => {
  const [optionWidths, setOptionWidths] = useState([]);
  const containerRef = useRef(null);
  const gap = 5; // Define the gap between options

  useEffect(() => {
    // Calculate the width of each option
    if (containerRef.current) {
      const buttonElements = containerRef.current.querySelectorAll("button");
      const widths = Array.from(buttonElements).map((button) => button.offsetWidth);
      setOptionWidths(widths);
    }
  }, [options]);

  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        const buttonElements = containerRef.current.querySelectorAll("button");
        const widths = Array.from(buttonElements).map((button) => button.offsetWidth);
        setOptionWidths(widths);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [options, containerRef]);

  const selectedIndex = options.indexOf(selectedOption);
  const highlightWidth = optionWidths[selectedIndex] || 0;
  const highlightTranslateX = optionWidths.slice(0, selectedIndex).reduce((acc, widthVal) => acc + widthVal + gap, 0);

  const totalWidth = optionWidths.reduce((acc, widthVal) => acc + widthVal, 0) + gap * (options.length - 1);

  const mergedStyle = mergeStyles(baseStyle, overrideStyle);

  return (
    <div
      className={`relative flex items-center p-1 ${mergedStyle.backgroundColor} rounded-md ${mergedStyle.height}`}
      ref={containerRef}
      style={{ width: width != null ? width : `${totalWidth + gap * 2}px` }}
    >
      <div
        className={`absolute top-1 bottom-1 ${mergedStyle.selectedColor} rounded-md transition-transform duration-300 ease-in-out`}
        style={{
          width: `${highlightWidth}px`,
          transform: `translateX(${highlightTranslateX}px)`,
        }}
      ></div>
      {options.map((option, index) => (
        <button
          key={option}
          onClick={() => setSelectedOption(option)}
          className={`px-1 md:px-2.5 relative z-10 text-[10px] md:text-[14px] font-semibold transition-all duration-300 ${selectedOption === option ? mergedStyle.selectedTextColor : mergedStyle.textColor}`}
          style={{
            marginLeft: index === 0 ? 0 : gap / 2,
            marginRight: index === options.length - 1 ? 0 : gap / 2,
            whiteSpace: "nowrap",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {option}
        </button>
      ))}
    </div>
  );
};

export default MultiToggleOptions;
